import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { SOCIAL } from "@/lib/config";
import Icon from "@/components/shared/Icon";

export default function Footer() {
  const { t, lp } = useLang();

  const explore = [
    { to: "/learn", key: "nav.learn" },
    { to: "/play", key: "nav.play" },
    { to: "/stories", key: "nav.stories" },
    { to: "/community", key: "nav.community" },
  ];
  const mission = [
    { to: "/impact", key: "nav.impact" },
    { to: "/about", key: "nav.about" },
    { to: "/token", key: "nav.token" },
    { to: "/faq", key: "nav.faq" },
  ];
  const legal = [
    { to: "/legal/privacy", key: "legal.privacy" },
    { to: "/legal/terms", key: "legal.terms" },
    { to: "/legal/disclaimer", key: "legal.disclaimer" },
    { to: "/legal/risk", key: "legal.risk" },
  ];

  return (
    <footer className="mt-10 border-t border-[#147DEB]/10 bg-[#082B66] text-white">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-5">
          <div className="col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-11 w-11 items-center justify-center overflow-hidden rounded-2xl bg-white">
                <img src="/assets/lumora-logo.jpeg" alt="LUMORA logo" className="h-full w-full object-contain" />
              </span>
              <span className="font-display text-2xl font-bold">LUMORA</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/70">{t("footer.tagline")}</p>
            <p className="mt-3 inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1.5 text-xs font-semibold text-[#FFC928]">
              <Icon name="ShieldCheck" className="h-4 w-4" />
              {t("footer.wallet")}
            </p>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-[#FFC928]">{t("footer.explore")}</h4>
            <ul className="mt-4 space-y-2.5">
              {explore.map((l) => (
                <li key={l.key}>
                  <Link to={lp(l.to)} className="text-sm text-white/75 transition-colors hover:text-white">{t(l.key)}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-[#FFC928]">{t("footer.mission")}</h4>
            <ul className="mt-4 space-y-2.5">
              {mission.map((l) => (
                <li key={l.key}>
                  <Link to={lp(l.to)} className="text-sm text-white/75 transition-colors hover:text-white">{t(l.key)}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-[#FFC928]">{t("footer.legal")}</h4>
            <ul className="mt-4 space-y-2.5">
              {legal.map((l) => (
                <li key={l.key}>
                  <Link to={lp(l.to)} className="text-sm text-white/75 transition-colors hover:text-white">{t(l.key)}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-white/60">© {new Date().getFullYear()} {t("footer.rights")}</p>
          <div className="flex items-center gap-3">
            <span className="text-xs text-white/60">{t("footer.follow")}:</span>
            {SOCIAL.xUrl ? (
              <a
                href={SOCIAL.xUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-x-link"
                className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-white/20"
                aria-label="X (Twitter)"
              >
                <Icon name="Twitter" className="h-4 w-4" />
              </a>
            ) : (
              <span
                data-testid="footer-x-placeholder"
                className="inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1.5 text-xs font-semibold text-white/70"
              >
                <Icon name="Twitter" className="h-4 w-4" />
                {t("footer.xPlaceholder")}
              </span>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}
